<template>
  <div class="page-content">
    <div class="container">
      <div class="row mb-4 justify-content-center">
        <div class="col-lg-7 text-center">
          <a v-on:click="$router.go(-1)" class="float-start cursor-pointer">
            <svg
              width="12"
              height="16"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.40059 10.7993L1.60059 5.99932L6.40059 1.19932"
                stroke="#001D21"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
          <h1 class="page-title">Settings</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-7">
          <div class="card p-3 rounded-4 shadow-sm bg-light mb-5">
            <div class="row justify-content-center">
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a v-on:click="this.$router.push('/working-time')" class="text-brand">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="26"
                          height="28"
                          class="icon"
                          viewBox="0 0 26 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.5554 6.22217V13.9999C15.5554 14.8555 14.8554 15.5555 13.9999 15.5555H5.44434V9.33328C5.44434 7.61439 6.83656 6.22217 8.55545 6.22217H15.5554Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M20.9999 15.5552V17.8885C20.9999 19.1796 19.9577 20.2218 18.6666 20.2218H17.8888C17.8888 19.3663 17.1888 18.6663 16.3332 18.6663C15.4777 18.6663 14.7777 19.3663 14.7777 20.2218H11.6666C11.6666 19.3663 10.9666 18.6663 10.111 18.6663C9.25545 18.6663 8.55545 19.3663 8.55545 20.2218H7.77767C6.48656 20.2218 5.44434 19.1796 5.44434 17.8885V15.5552H13.9999C14.8554 15.5552 15.5554 14.8552 15.5554 13.9996V8.55518H16.9866C17.5466 8.55518 18.0599 8.85852 18.3399 9.34074L19.6699 11.6663H18.6666C18.2388 11.6663 17.8888 12.0163 17.8888 12.4441V14.7774C17.8888 15.2052 18.2388 15.5552 18.6666 15.5552H20.9999Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.1102 21.7776C10.9694 21.7776 11.6658 21.0812 11.6658 20.2221C11.6658 19.3629 10.9694 18.6665 10.1102 18.6665C9.25113 18.6665 8.55469 19.3629 8.55469 20.2221C8.55469 21.0812 9.25113 21.7776 10.1102 21.7776Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M16.3329 21.7776C17.192 21.7776 17.8885 21.0812 17.8885 20.2221C17.8885 19.3629 17.192 18.6665 16.3329 18.6665C15.4738 18.6665 14.7773 19.3629 14.7773 20.2221C14.7773 21.0812 15.4738 21.7776 16.3329 21.7776Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M20.9998 13.9998V15.5554H18.6664C18.2387 15.5554 17.8887 15.2054 17.8887 14.7776V12.4443C17.8887 12.0165 18.2387 11.6665 18.6664 11.6665H19.6698L20.9998 13.9998Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M23.5271 17.5005C23.5271 22.0155 20.1798 25.6672 16.041 25.6672L17.1639 23.6255"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2.13867 10.5002C2.13867 5.98516 5.48603 2.3335 9.62478 2.3335L8.50188 4.37516"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div>Pick up & Drop</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    href="javascript:void(0)"
                    class="text-brand"
                    v-on:click="this.$router.push('/working-time')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="22"
                          height="22"
                          class="icon"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="2"
                            y="3.00049"
                            width="18"
                            height="18"
                            rx="3"
                            fill="#DEE9EA"
                          />
                          <path
                            d="M5.97229 6.98251H16.4485M5.50004 1.26866V3.13271M5.50004 3.13271L16.5 3.13251M5.50004 3.13271C3.67744 3.13271 2.20011 4.61006 2.2002 6.43266L2.20071 17.4326C2.20079 19.2551 3.67823 20.7324 5.50071 20.7324H16.5007C18.3233 20.7324 19.8008 19.2549 19.8007 17.4323L19.8002 6.43235C19.8001 4.60987 18.3225 3.13251 16.5 3.13251M16.5 1.26855V3.13251M8.80086 16.8824V10.2824L6.60086 11.9324M14.8509 16.8824V10.2824L12.6509 11.9324"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <div>Set Working Days</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    href="javascript:void(0)"
                    class="text-brand"
                    v-on:click="this.$router.push('/notification')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="22"
                          height="22"
                          class="icon"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.2735 16.0673H18.7275C19.1569 16.0673 19.4004 15.4377 19.1475 15.077C18.5621 14.2418 17.9933 13.0105 17.9933 11.5257L18.0185 9.49486C18.0185 5.4664 14.8762 2.20068 11 2.20068C7.18005 2.20068 4.08337 5.41899 4.08337 9.38897L4.05819 11.5257C4.05819 13.0004 3.46915 14.2249 2.85887 15.0599C2.59587 15.4197 2.83871 16.0673 3.2735 16.0673Z"
                            fill="#DEE9EA"
                          />
                          <path
                            d="M8.25 18.9118C8.97979 19.4646 9.94351 19.8007 11 19.8007C12.0565 19.8007 13.0202 19.4646 13.75 18.9118M3.2735 16.0673C2.83871 16.0673 2.59587 15.4197 2.85887 15.0599C3.46915 14.2249 4.05819 13.0004 4.05819 11.5257L4.08337 9.38897C4.08337 5.41899 7.18005 2.20068 11 2.20068C14.8762 2.20068 18.0185 5.4664 18.0185 9.49486L17.9933 11.5257C17.9933 13.0105 18.5621 14.2418 19.1475 15.077C19.4004 15.4377 19.1569 16.0673 18.7275 16.0673H3.2735Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div>Notifications</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/photos-video')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="20"
                          height="20"
                          class="icon"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_34351_37371)">
                            <path
                              d="M15 2H4C2.34315 2 1 3.34315 1 5V16C1 17.6569 2.34315 19 4 19H15C16.6569 19 18 17.6569 18 16V5C18 3.34315 16.6569 2 15 2Z"
                              fill="#DEE9EA"
                            />
                            <path
                              d="M12.6926 9.17161L12.2491 8.6964L12.2474 8.69795L12.6926 9.17161ZM9.65671 12.0248L10.1002 12.5L10.1019 12.4985L9.65671 12.0248ZM9.03871 12.0113L8.57335 12.4651L8.57428 12.4661L9.03871 12.0113ZM7.45709 10.6297L7.92263 10.1761L7.92175 10.1752L7.45709 10.6297ZM6.82689 10.628L6.3647 10.171L6.36378 10.1719L6.82689 10.628ZM13.7246 5.11857V4.46857C13.3656 4.46857 13.0746 4.75959 13.0746 5.11857H13.7246ZM14.0284 5.11857H14.6784C14.6784 4.75959 14.3874 4.46857 14.0284 4.46857V5.11857ZM14.0284 5.3759V6.0259C14.3874 6.0259 14.6784 5.73488 14.6784 5.3759H14.0284ZM13.7246 5.3759H13.0746C13.0746 5.73488 13.3656 6.0259 13.7246 6.0259V5.3759ZM0.75 4.5875V15.2125H2.05V4.5875H0.75ZM4.5875 19.05H15.2125V17.75H4.5875V19.05ZM19.05 15.2125V4.5875H17.75V15.2125H19.05ZM15.2125 0.75H4.5875V2.05H15.2125V0.75ZM19.05 4.5875C19.05 2.46811 17.3319 0.75 15.2125 0.75V2.05C16.6139 2.05 17.75 3.18608 17.75 4.5875H19.05ZM15.2125 19.05C17.3319 19.05 19.05 17.3319 19.05 15.2125H17.75C17.75 16.6139 16.6139 17.75 15.2125 17.75V19.05ZM0.75 15.2125C0.75 17.3319 2.46811 19.05 4.5875 19.05V17.75C3.18608 17.75 2.05 16.6139 2.05 15.2125H0.75ZM2.05 4.5875C2.05 3.18608 3.18608 2.05 4.5875 2.05V0.75C2.46811 0.75 0.75 2.46811 0.75 4.5875H2.05ZM7.19192 11.1772C7.2348 11.1409 7.27048 11.104 7.28211 11.0921L6.35538 10.1804C6.35139 10.1844 6.34838 10.1876 6.34609 10.1899C6.34395 10.192 6.34288 10.1931 6.34248 10.1935C6.34152 10.1944 6.34499 10.1909 6.35154 10.1854L7.19192 11.1772ZM5.27154 12.8044L7.19192 11.1772L6.35154 10.1854L4.43115 11.8125L5.27154 12.8044ZM5.27968 12.7905C5.27033 12.8039 5.26311 12.8115 5.26152 12.8132C5.26015 12.8146 5.26242 12.8121 5.27154 12.8044L4.43115 11.8125C4.37348 11.8614 4.28825 11.9393 4.21262 12.0479L5.27968 12.7905ZM5.2375 12.925C5.2375 12.8767 5.25231 12.8298 5.27968 12.7905L4.21262 12.0479C4.03412 12.3045 3.9375 12.6103 3.9375 12.925H5.2375ZM5.2375 14.7698V12.925H3.9375V14.7698H5.2375ZM5.03021 14.5625C5.14469 14.5625 5.2375 14.6553 5.2375 14.7698H3.9375C3.9375 15.3733 4.42672 15.8625 5.03021 15.8625V14.5625ZM14.7698 14.5625H5.03021V15.8625H14.7698V14.5625ZM14.5625 14.7698C14.5625 14.6553 14.6553 14.5625 14.7698 14.5625V15.8625C15.3733 15.8625 15.8625 15.3733 15.8625 14.7698H14.5625ZM14.5625 11.388V14.7698H15.8625V11.388H14.5625ZM14.4901 11.2182C14.5364 11.2626 14.5625 11.3239 14.5625 11.388H15.8625C15.8625 10.9699 15.692 10.5699 15.3904 10.2804L14.4901 11.2182ZM12.8511 9.64481L14.4901 11.2182L15.3904 10.2804L13.7514 8.70697L12.8511 9.64481ZM13.1361 9.64681C13.0556 9.72191 12.9305 9.72101 12.8511 9.64481L13.7514 8.70697C13.3329 8.30516 12.6732 8.30052 12.2491 8.6964L13.1361 9.64681ZM10.1019 12.4985L13.1377 9.64521L12.2474 8.69795L9.21161 11.5512L10.1019 12.4985ZM8.57428 12.4661C8.98548 12.8861 9.66301 12.9081 10.1002 12.5L9.21321 11.5497C9.29641 11.472 9.42471 11.4765 9.50321 11.5566L8.57428 12.4661ZM8.56494 12.4565L8.57335 12.4651L9.50411 11.5575L9.49611 11.5494L8.56494 12.4565ZM8.5618 12.4524C8.55573 12.4471 8.55251 12.4439 8.55342 12.4448C8.5538 12.4451 8.55479 12.4461 8.55678 12.4481C8.55891 12.4503 8.56122 12.4527 8.56494 12.4565L9.49611 11.5494C9.48531 11.5383 9.45261 11.5041 9.41291 11.4697L8.5618 12.4524ZM7.08288 11.1714L8.5618 12.4524L9.41291 11.4697L7.93401 10.1887L7.08288 11.1714ZM6.99891 11.0909C7.00977 11.1021 7.04305 11.1369 7.08288 11.1714L7.93401 10.1887C7.94009 10.194 7.94332 10.1972 7.94242 10.1964C7.94204 10.196 7.94105 10.195 7.93905 10.193C7.93692 10.1908 7.93459 10.1884 7.93086 10.1846L6.99891 11.0909ZM6.99156 11.0834L6.99891 11.0909L7.93086 10.1846L7.92263 10.1761L6.99156 11.0834ZM7.28908 11.085C7.20691 11.1681 7.07427 11.1679 6.99243 11.0843L7.92175 10.1752C7.49529 9.73921 6.79297 9.73791 6.3647 10.171L7.28908 11.085ZM7.28211 11.0921L7.29 11.0841L6.36378 10.1719L6.35538 10.1804L7.28211 11.0921ZM13.7246 5.76857H14.0284V4.46857H13.7246V5.76857ZM13.3784 5.11857V5.3759H14.6784V5.11857H13.3784ZM14.0284 4.7259H13.7246V6.0259H14.0284V4.7259ZM14.3746 5.3759V5.11857H13.0746V5.3759H14.3746Z"
                              fill="#004852"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_34351_37371">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                        <div>Workshop Photos & Videos</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/rate-card')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="22"
                          height="22"
                          class="icon"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.0736 14.665H8.49023"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.6052 2.30845L11.5777 2.37262L8.91938 8.54179H6.30687C5.68354 8.54179 5.08771 8.67012 4.54688 8.89929L6.15104 5.06762L6.18771 4.97595L6.25188 4.82929C6.27021 4.77429 6.28854 4.71929 6.31604 4.67345C7.51688 1.89595 8.87354 1.26345 11.6052 2.30845Z"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M16.5456 8.72477C16.1331 8.59644 15.6931 8.54144 15.2531 8.54144H8.91895L11.5773 2.37227L11.6048 2.30811C11.7423 2.35394 11.8706 2.41811 12.0081 2.47311L14.0339 3.32561C15.1614 3.79311 15.9498 4.27894 16.4264 4.86561C16.5181 4.97561 16.5914 5.07644 16.6556 5.19561C16.7381 5.32394 16.8023 5.45227 16.8389 5.58977C16.8756 5.67227 16.9031 5.75477 16.9214 5.82811C17.1689 6.59811 17.0223 7.54227 16.5456 8.72477Z"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19.7279 13.0153V14.8028C19.7279 14.9862 19.7188 15.1695 19.7096 15.3528C19.5354 18.552 17.7479 20.1653 14.3562 20.1653H7.20625C6.98625 20.1653 6.76625 20.147 6.55542 20.1195C3.64042 19.927 2.08208 18.3687 1.88958 15.4537C1.86208 15.2428 1.84375 15.0228 1.84375 14.8028V13.0153C1.84375 11.1728 2.96208 9.58699 4.55708 8.89949C5.10708 8.67033 5.69375 8.54199 6.31708 8.54199H15.2637C15.7129 8.54199 16.1529 8.60616 16.5562 8.72533C18.3804 9.28449 19.7279 10.9895 19.7279 13.0153Z"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div>Ratecard Photos</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/services')"
                    class="text-brand"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="24"
                          class="icon"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.5 7V2L10.5 2.5V4.5L7.00028 6L5.5 4.5L4 6L5.5 8L4 10.5L2 11V13H4L5.5 16.5L4 18L5 19.5L7.5 18.5H9.5L10 21.5L13.5 22V17C9.9 17.4 7.50019 15.1667 7.00028 14C5.40028 9.2 9.5 7.33333 11.5 7Z"
                            fill="#DEE9EA"
                            stroke="#DEE9EA"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19.0307 3.38881C19.0307 2.87375 19.0274 2.3587 19.0313 1.84299C19.0372 1.15974 19.638 0.806986 20.2427 1.12832C23.587 2.90713 23.8893 7.60416 20.7957 9.78873C20.6413 9.89802 20.5935 10.0073 20.5941 10.1879C20.5994 13.5165 20.6 16.8444 20.5968 20.173C20.5955 21.5159 19.7676 22.5905 18.5051 22.9086C16.8304 23.3301 15.1543 22.0709 15.1183 20.3405C15.0935 19.1553 15.1111 17.9688 15.1111 16.7835C15.1111 14.5754 15.1092 12.3673 15.1144 10.1598C15.1144 9.99553 15.0673 9.89606 14.9298 9.80051C11.8179 7.62575 12.1124 2.9091 15.4691 1.12767C16.0719 0.80764 16.6746 1.16366 16.6772 1.84822C16.6818 2.88684 16.6825 3.92546 16.674 4.96408C16.6727 5.12966 16.7126 5.22914 16.8768 5.26382C16.8925 5.2671 16.9083 5.27364 16.9233 5.27953C17.2342 5.40061 17.5483 5.62312 17.8553 5.61527C18.1923 5.6061 18.5215 5.37705 18.8592 5.25793C19.0032 5.20754 19.0339 5.12377 19.0326 4.98372C19.0254 4.4523 19.03 3.92088 19.03 3.38881H19.0307ZM15.1111 3.43135C15.0228 3.5413 14.9704 3.59889 14.9272 3.66303C13.7832 5.36068 14.3277 7.69709 16.1144 8.69317C16.5202 8.91961 16.6857 9.2187 16.6844 9.68009C16.674 13.0165 16.6785 16.3529 16.6785 19.69C16.6785 19.8942 16.672 20.099 16.6818 20.3032C16.7106 20.9262 17.2342 21.4217 17.8553 21.421C18.5234 21.421 19.0287 20.8909 19.0293 20.1789C19.0313 16.6461 19.032 13.1134 19.0274 9.58061C19.0274 9.19775 19.1786 8.93204 19.513 8.74422C20.886 7.97327 21.5523 6.62705 21.3304 5.06291C21.2473 4.47586 21.015 3.94641 20.5981 3.42415C20.5981 3.57337 20.5981 3.6519 20.5981 3.73044C20.5981 4.37638 20.5981 5.02233 20.5981 5.66828C20.5981 6.04328 20.4273 6.3103 20.0804 6.45231C19.4469 6.71148 18.816 6.98046 18.1714 7.20821C17.9809 7.27562 17.7263 7.27431 17.5359 7.2069C16.8912 6.9785 16.261 6.70952 15.6275 6.45101C15.28 6.30899 15.1124 6.04066 15.1124 5.66566C15.1124 5.12573 15.1124 4.58646 15.1124 4.04654C15.1124 3.86198 15.1124 3.67743 15.1124 3.43135H15.1111Z"
                            fill="#004852"
                            stroke="white"
                            stroke-width="0.13305"
                            stroke-miterlimit="10"
                          />
                          <path
                            d="M12.7925 21.4084C12.841 21.2912 12.8737 21.18 12.93 21.0818C13.1054 20.7775 13.4549 20.6368 13.7906 20.7245C14.1401 20.8154 14.375 21.1158 14.3789 21.4758C14.3875 22.25 13.7022 22.9614 12.8973 22.9862C12.2853 23.0052 11.6728 23.0039 11.0609 22.9862C10.2847 22.9647 9.63807 22.3279 9.57525 21.5543C9.54514 21.1793 9.50784 20.805 9.48689 20.4293C9.47969 20.3049 9.43781 20.2474 9.32197 20.2022C8.89788 20.036 8.48034 19.8508 8.0556 19.6865C7.98492 19.659 7.86319 19.6708 7.80625 19.7166C7.51829 19.945 7.24669 20.193 6.96462 20.4286C6.29315 20.9902 5.42142 20.9581 4.79445 20.3455C4.40898 19.9686 4.02808 19.5864 3.65177 19.2002C3.03004 18.5628 2.99928 17.6858 3.57062 17.0078C3.8023 16.7329 4.03463 16.4581 4.27285 16.1891C4.35597 16.0955 4.35531 16.0242 4.30361 15.909C4.12102 15.4999 3.94955 15.0844 3.79117 14.6655C3.74209 14.5359 3.67664 14.4954 3.54641 14.4882C3.18776 14.4685 2.83043 14.4319 2.47245 14.4057C1.64718 14.3448 1.01628 13.6825 1.00516 12.8514C0.997958 12.2872 0.998612 11.7224 1.00516 11.1583C1.01432 10.3114 1.64194 9.64911 2.48161 9.58759C2.8481 9.56076 3.2146 9.53589 3.57913 9.4927C3.65177 9.48419 3.74732 9.40827 3.77743 9.33956C3.96198 8.92201 4.13672 8.49989 4.29837 8.07319C4.32717 7.99727 4.31146 7.86703 4.26173 7.80421C4.04575 7.52737 3.80884 7.2669 3.5824 6.99857C2.99732 6.30747 3.02546 5.43181 3.65701 4.78782C4.03463 4.403 4.41487 4.02015 4.80034 3.64318C5.42404 3.03323 6.30035 3.00443 6.97051 3.56857C7.2395 3.79501 7.50782 4.02146 7.76895 4.2564C7.87301 4.34999 7.95481 4.36373 8.08898 4.30287C8.48885 4.12093 8.89658 3.95666 9.30692 3.79829C9.43061 3.75051 9.48297 3.69554 9.48951 3.55745C9.50718 3.1903 9.5471 2.8238 9.57525 2.45731C9.63676 1.65691 10.2919 1.02667 11.0936 1.00573C11.3874 0.997873 11.6813 0.998527 11.9751 1.00507C12.4175 1.01489 12.7566 1.3539 12.7605 1.78126C12.7644 2.21843 12.4215 2.56333 11.966 2.57315C11.6976 2.57904 11.4293 2.57446 11.1394 2.57446C11.0923 3.15954 11.0438 3.7276 11.0026 4.29567C10.9679 4.77015 10.7801 5.01623 10.3239 5.13141C9.60731 5.31269 8.93257 5.59084 8.30037 5.97631C7.92275 6.20668 7.60534 6.17658 7.26633 5.88992C6.82392 5.51558 6.38543 5.13599 5.96658 4.77735C5.57064 5.1733 5.18123 5.5627 4.76958 5.97435C5.05427 6.30747 5.37037 6.67723 5.68582 7.047C5.76043 7.13404 5.83504 7.22043 5.90703 7.30944C6.15245 7.6131 6.19237 7.93117 5.99276 8.26429C5.59092 8.9351 5.29315 9.64519 5.10728 10.4057C5.015 10.7846 4.74406 10.9862 4.3455 11.0182C3.76107 11.0647 3.17598 11.1112 2.58174 11.1583V12.8396C3.14981 12.8854 3.71591 12.9319 4.28201 12.9764C4.77744 13.015 5.00453 13.1982 5.12626 13.6747C5.30493 14.3756 5.57587 15.0372 5.94891 15.6583C6.20218 16.0791 6.17404 16.3743 5.85271 16.7539C5.48359 17.1897 5.11186 17.6223 4.74929 18.0471C5.15244 18.4489 5.54446 18.8403 5.94498 19.2395C6.36711 18.8776 6.7997 18.5045 7.23491 18.1341C7.61188 17.8134 7.909 17.7873 8.32851 18.0399C8.93388 18.4038 9.57655 18.6747 10.2611 18.8494C10.7893 18.9843 10.9633 19.2028 11.002 19.7375C11.0425 20.2919 11.0903 20.8455 11.1355 21.411H12.7912L12.7925 21.4084Z"
                            fill="#004852"
                            stroke="white"
                            stroke-width="0.13305"
                            stroke-miterlimit="10"
                          />
                          <path
                            d="M11.8997 17.4949C9.21774 17.4949 6.82767 15.3417 6.52466 12.6781C6.20856 9.89927 7.9769 7.20946 10.8774 6.61456C11.0757 6.57398 11.3055 6.57791 11.4966 6.63877C11.8199 6.74087 12.0011 7.08119 11.973 7.41627C11.9442 7.76378 11.6903 8.05109 11.3257 8.12046C10.5443 8.26837 9.84471 8.58512 9.27926 9.14926C8.15033 10.2756 7.77467 11.6303 8.24195 13.1519C8.70988 14.6755 9.79628 15.5675 11.3532 15.8718C11.9822 15.9949 12.6013 15.9117 13.2145 15.7311C13.3932 15.6781 13.6052 15.6657 13.7858 15.7062C14.1065 15.7789 14.3173 16.0885 14.3271 16.415C14.3375 16.7599 14.1327 17.0675 13.7911 17.1853C13.2008 17.3889 12.5941 17.5034 11.8997 17.4949Z"
                            fill="#004852"
                            stroke="white"
                            stroke-width="0.13305"
                            stroke-miterlimit="10"
                          />
                        </svg>

                        <div>Services</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3" v-if="is_cost == 'Y'">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/service-cost')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="24"
                          class="icon"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.5 7V2L10.5 2.5V4.5L7.00028 6L5.5 4.5L4 6L5.5 8L4 10.5L2 11V13H4L5.5 16.5L4 18L5 19.5L7.5 18.5H9.5L10 21.5L13.5 22V17C9.9 17.4 7.50019 15.1667 7.00028 14C5.40028 9.2 9.5 7.33333 11.5 7Z"
                            fill="#DEE9EA"
                            stroke="#DEE9EA"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19.0307 3.38881C19.0307 2.87375 19.0274 2.3587 19.0313 1.84299C19.0372 1.15974 19.638 0.806986 20.2427 1.12832C23.587 2.90713 23.8893 7.60416 20.7957 9.78873C20.6413 9.89802 20.5935 10.0073 20.5941 10.1879C20.5994 13.5165 20.6 16.8444 20.5968 20.173C20.5955 21.5159 19.7676 22.5905 18.5051 22.9086C16.8304 23.3301 15.1543 22.0709 15.1183 20.3405C15.0935 19.1553 15.1111 17.9688 15.1111 16.7835C15.1111 14.5754 15.1092 12.3673 15.1144 10.1598C15.1144 9.99553 15.0673 9.89606 14.9298 9.80051C11.8179 7.62575 12.1124 2.9091 15.4691 1.12767C16.0719 0.80764 16.6746 1.16366 16.6772 1.84822C16.6818 2.88684 16.6825 3.92546 16.674 4.96408C16.6727 5.12966 16.7126 5.22914 16.8768 5.26382C16.8925 5.2671 16.9083 5.27364 16.9233 5.27953C17.2342 5.40061 17.5483 5.62312 17.8553 5.61527C18.1923 5.6061 18.5215 5.37705 18.8592 5.25793C19.0032 5.20754 19.0339 5.12377 19.0326 4.98372C19.0254 4.4523 19.03 3.92088 19.03 3.38881H19.0307ZM15.1111 3.43135C15.0228 3.5413 14.9704 3.59889 14.9272 3.66303C13.7832 5.36068 14.3277 7.69709 16.1144 8.69317C16.5202 8.91961 16.6857 9.2187 16.6844 9.68009C16.674 13.0165 16.6785 16.3529 16.6785 19.69C16.6785 19.8942 16.672 20.099 16.6818 20.3032C16.7106 20.9262 17.2342 21.4217 17.8553 21.421C18.5234 21.421 19.0287 20.8909 19.0293 20.1789C19.0313 16.6461 19.032 13.1134 19.0274 9.58061C19.0274 9.19775 19.1786 8.93204 19.513 8.74422C20.886 7.97327 21.5523 6.62705 21.3304 5.06291C21.2473 4.47586 21.015 3.94641 20.5981 3.42415C20.5981 3.57337 20.5981 3.6519 20.5981 3.73044C20.5981 4.37638 20.5981 5.02233 20.5981 5.66828C20.5981 6.04328 20.4273 6.3103 20.0804 6.45231C19.4469 6.71148 18.816 6.98046 18.1714 7.20821C17.9809 7.27562 17.7263 7.27431 17.5359 7.2069C16.8912 6.9785 16.261 6.70952 15.6275 6.45101C15.28 6.30899 15.1124 6.04066 15.1124 5.66566C15.1124 5.12573 15.1124 4.58646 15.1124 4.04654C15.1124 3.86198 15.1124 3.67743 15.1124 3.43135H15.1111Z"
                            fill="#004852"
                            stroke="white"
                            stroke-width="0.13305"
                            stroke-miterlimit="10"
                          />
                          <path
                            d="M12.7925 21.4084C12.841 21.2912 12.8737 21.18 12.93 21.0818C13.1054 20.7775 13.4549 20.6368 13.7906 20.7245C14.1401 20.8154 14.375 21.1158 14.3789 21.4758C14.3875 22.25 13.7022 22.9614 12.8973 22.9862C12.2853 23.0052 11.6728 23.0039 11.0609 22.9862C10.2847 22.9647 9.63807 22.3279 9.57525 21.5543C9.54514 21.1793 9.50784 20.805 9.48689 20.4293C9.47969 20.3049 9.43781 20.2474 9.32197 20.2022C8.89788 20.036 8.48034 19.8508 8.0556 19.6865C7.98492 19.659 7.86319 19.6708 7.80625 19.7166C7.51829 19.945 7.24669 20.193 6.96462 20.4286C6.29315 20.9902 5.42142 20.9581 4.79445 20.3455C4.40898 19.9686 4.02808 19.5864 3.65177 19.2002C3.03004 18.5628 2.99928 17.6858 3.57062 17.0078C3.8023 16.7329 4.03463 16.4581 4.27285 16.1891C4.35597 16.0955 4.35531 16.0242 4.30361 15.909C4.12102 15.4999 3.94955 15.0844 3.79117 14.6655C3.74209 14.5359 3.67664 14.4954 3.54641 14.4882C3.18776 14.4685 2.83043 14.4319 2.47245 14.4057C1.64718 14.3448 1.01628 13.6825 1.00516 12.8514C0.997958 12.2872 0.998612 11.7224 1.00516 11.1583C1.01432 10.3114 1.64194 9.64911 2.48161 9.58759C2.8481 9.56076 3.2146 9.53589 3.57913 9.4927C3.65177 9.48419 3.74732 9.40827 3.77743 9.33956C3.96198 8.92201 4.13672 8.49989 4.29837 8.07319C4.32717 7.99727 4.31146 7.86703 4.26173 7.80421C4.04575 7.52737 3.80884 7.2669 3.5824 6.99857C2.99732 6.30747 3.02546 5.43181 3.65701 4.78782C4.03463 4.403 4.41487 4.02015 4.80034 3.64318C5.42404 3.03323 6.30035 3.00443 6.97051 3.56857C7.2395 3.79501 7.50782 4.02146 7.76895 4.2564C7.87301 4.34999 7.95481 4.36373 8.08898 4.30287C8.48885 4.12093 8.89658 3.95666 9.30692 3.79829C9.43061 3.75051 9.48297 3.69554 9.48951 3.55745C9.50718 3.1903 9.5471 2.8238 9.57525 2.45731C9.63676 1.65691 10.2919 1.02667 11.0936 1.00573C11.3874 0.997873 11.6813 0.998527 11.9751 1.00507C12.4175 1.01489 12.7566 1.3539 12.7605 1.78126C12.7644 2.21843 12.4215 2.56333 11.966 2.57315C11.6976 2.57904 11.4293 2.57446 11.1394 2.57446C11.0923 3.15954 11.0438 3.7276 11.0026 4.29567C10.9679 4.77015 10.7801 5.01623 10.3239 5.13141C9.60731 5.31269 8.93257 5.59084 8.30037 5.97631C7.92275 6.20668 7.60534 6.17658 7.26633 5.88992C6.82392 5.51558 6.38543 5.13599 5.96658 4.77735C5.57064 5.1733 5.18123 5.5627 4.76958 5.97435C5.05427 6.30747 5.37037 6.67723 5.68582 7.047C5.76043 7.13404 5.83504 7.22043 5.90703 7.30944C6.15245 7.6131 6.19237 7.93117 5.99276 8.26429C5.59092 8.9351 5.29315 9.64519 5.10728 10.4057C5.015 10.7846 4.74406 10.9862 4.3455 11.0182C3.76107 11.0647 3.17598 11.1112 2.58174 11.1583V12.8396C3.14981 12.8854 3.71591 12.9319 4.28201 12.9764C4.77744 13.015 5.00453 13.1982 5.12626 13.6747C5.30493 14.3756 5.57587 15.0372 5.94891 15.6583C6.20218 16.0791 6.17404 16.3743 5.85271 16.7539C5.48359 17.1897 5.11186 17.6223 4.74929 18.0471C5.15244 18.4489 5.54446 18.8403 5.94498 19.2395C6.36711 18.8776 6.7997 18.5045 7.23491 18.1341C7.61188 17.8134 7.909 17.7873 8.32851 18.0399C8.93388 18.4038 9.57655 18.6747 10.2611 18.8494C10.7893 18.9843 10.9633 19.2028 11.002 19.7375C11.0425 20.2919 11.0903 20.8455 11.1355 21.411H12.7912L12.7925 21.4084Z"
                            fill="#004852"
                            stroke="white"
                            stroke-width="0.13305"
                            stroke-miterlimit="10"
                          />
                          <path
                            d="M11.8997 17.4949C9.21774 17.4949 6.82767 15.3417 6.52466 12.6781C6.20856 9.89927 7.9769 7.20946 10.8774 6.61456C11.0757 6.57398 11.3055 6.57791 11.4966 6.63877C11.8199 6.74087 12.0011 7.08119 11.973 7.41627C11.9442 7.76378 11.6903 8.05109 11.3257 8.12046C10.5443 8.26837 9.84471 8.58512 9.27926 9.14926C8.15033 10.2756 7.77467 11.6303 8.24195 13.1519C8.70988 14.6755 9.79628 15.5675 11.3532 15.8718C11.9822 15.9949 12.6013 15.9117 13.2145 15.7311C13.3932 15.6781 13.6052 15.6657 13.7858 15.7062C14.1065 15.7789 14.3173 16.0885 14.3271 16.415C14.3375 16.7599 14.1327 17.0675 13.7911 17.1853C13.2008 17.3889 12.5941 17.5034 11.8997 17.4949Z"
                            fill="#004852"
                            stroke="white"
                            stroke-width="0.13305"
                            stroke-miterlimit="10"
                          />
                        </svg>

                        <div>Periodic Services Cost</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>

              <div class="col-lg-6 mb-3" v-if="is_cost == 'Y'">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/import-service-cost')"
                    class="text-brand"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="4.66699"
                            y="17.5"
                            width="18.6667"
                            height="5.83333"
                            fill="#DEE9EA"
                          />
                          <path
                            d="M11.1183 11.1183L13.125 9.11168V19.8333C13.125 20.3117 13.5217 20.7083 14 20.7083C14.4783 20.7083 14.875 20.3117 14.875 19.8333V9.11168L16.8817 11.1183C17.0567 11.2933 17.2783 11.375 17.5 11.375C17.7217 11.375 17.9433 11.2933 18.1183 11.1183C18.4567 10.78 18.4567 10.22 18.1183 9.88168L14.6183 6.38168C14.28 6.04335 13.72 6.04335 13.3817 6.38168L9.88168 9.88168C9.54335 10.22 9.54335 10.78 9.88168 11.1183C10.22 11.4567 10.78 11.4567 11.1183 11.1183Z"
                            fill="#004852"
                          />
                          <path
                            d="M23.3337 16.625C22.8553 16.625 22.4587 17.0217 22.4587 17.5V21C22.4587 21.805 21.8053 22.4583 21.0003 22.4583H7.00033C6.19533 22.4583 5.54199 21.805 5.54199 21V17.5C5.54199 17.0217 5.14533 16.625 4.66699 16.625C4.18866 16.625 3.79199 17.0217 3.79199 17.5V21C3.79199 22.7733 5.22699 24.2083 7.00033 24.2083H21.0003C22.7737 24.2083 24.2087 22.7733 24.2087 21V17.5C24.2087 17.0217 23.812 16.625 23.3337 16.625Z"
                            fill="#004852"
                          />
                        </svg>

                        <div>Upload Service Cost</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>

              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/select-vehicle')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="26"
                          class="icon"
                          height="22"
                          viewBox="0 0 26 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.2178 2.59424H7.78283C5.50033 2.59424 4.99616 3.73091 4.70283 5.12424L3.66699 10.0834H18.3337L17.2978 5.12424C17.0045 3.73091 16.5003 2.59424 14.2178 2.59424Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M20.157 18.1685C20.2578 19.241 19.3962 20.1668 18.2962 20.1668H16.5728C15.5828 20.1668 15.4453 19.7452 15.2712 19.2227L15.0878 18.6727C14.8312 17.921 14.6662 17.4168 13.3462 17.4168H8.65285C7.33285 17.4168 7.14035 17.9852 6.91118 18.6727L6.72785 19.2227C6.55368 19.7452 6.41618 20.1668 5.42618 20.1668H3.70285C2.60285 20.1668 1.74118 19.241 1.84201 18.1685L2.35535 12.586C2.48368 11.211 2.74951 10.0835 5.15118 10.0835H16.8478C19.2495 10.0835 19.5153 11.211 19.6437 12.586L20.157 18.1685Z"
                            fill="#DEE9EA"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M3.66667 7.3335H2.75"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M19.2497 7.3335H18.333"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11 2.75V4.58333"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.625 4.5835H12.375"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5.5 13.75H8.25"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.75 13.75H16.5"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <rect
                            x="13"
                            y="4.74951"
                            width="12"
                            height="15.75"
                            rx="3"
                            fill="#DEE9EA"
                          />
                          <rect
                            x="16"
                            y="2.99951"
                            width="6"
                            height="3.5"
                            rx="1.75"
                            fill="white"
                          />
                          <path
                            d="M25 8.29881V16.9502C25 19.6122 23.6575 20.4995 22 20.4995H16C14.3425 20.4995 13 19.6122 13 16.9502V8.29881C13 5.415 14.3425 4.74951 16 4.74951C16 5.29965 16.1875 5.79655 16.495 6.16035C16.8025 6.52416 17.41 6.49951 17.875 6.49951H19H20.5C21.43 6.49951 22 5.84979 22 4.74951C23.6575 4.74951 25 5.415 25 8.29881Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M22 4.74951C22 5.71396 21.2425 6.49951 20.3125 6.49951H17.6875C17.2225 6.49951 16.8025 6.30506 16.495 5.98618C16.1875 5.66729 16 5.23173 16 4.74951C16 3.78507 16.7575 2.99951 17.6875 2.99951H20.3125C20.7775 2.99951 21.1975 3.19396 21.505 3.51285C21.8125 3.83174 22 4.26729 22 4.74951Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.25 9.99951H18.25"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.25 13.4995H21.25"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div>Vehicles List</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a @click="moveToOutlet" class="text-brand">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="22"
                          height="22"
                          class="icon"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.2593 10.2847V14.4005C19.2593 18.5163 17.6184 20.1664 13.4934 20.1664H8.55264C8.02097 20.1664 7.5351 20.1389 7.08594 20.0747"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M2.78711 14.2264V10.2847"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.0277 11.0002C12.7052 11.0002 13.9427 9.63438 13.7777 7.95688L13.1635 1.8335H8.88272L8.26857 7.95688C8.10357 9.63438 9.35025 11.0002 11.0277 11.0002Z"
                            fill="#DEE9EA"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M16.8028 11.0002C18.6545 11.0002 20.0111 9.49681 19.8278 7.65431L19.5711 5.13347C19.2411 2.75014 18.3244 1.8335 15.9228 1.8335H13.127L13.7686 8.25934C13.9336 9.77184 15.2903 11.0002 16.8028 11.0002Z"
                            fill="#DEE9EA"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5.19715 11.0002C6.70965 11.0002 8.07547 9.77184 8.22214 8.25934L8.42383 6.23354L8.86382 1.8335H6.06799C3.66633 1.8335 2.74968 2.75014 2.41968 5.13347L2.16298 7.65431C1.97965 9.49681 3.34548 11.0002 5.19715 11.0002Z"
                            fill="#DEE9EA"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M8.25033 17.4167C8.25033 18.1042 8.05781 18.7551 7.71864 19.3051C7.54448 19.5984 7.33364 19.8642 7.08614 20.075C7.05864 20.1117 7.03116 20.1392 6.9945 20.1667C6.35283 20.7442 5.50949 21.0833 4.58366 21.0833C3.46533 21.0833 2.46613 20.5791 1.80613 19.7908C1.7878 19.7633 1.76035 19.745 1.74201 19.7175C1.63201 19.5892 1.53117 19.4517 1.44867 19.3051C1.10951 18.7551 0.916992 18.1042 0.916992 17.4167C0.916992 16.2617 1.44866 15.2258 2.29199 14.5567C2.44783 14.4283 2.61281 14.3184 2.78697 14.2267C3.31864 13.9242 3.93283 13.75 4.58366 13.75C5.50033 13.75 6.3253 14.08 6.96697 14.6391C7.07697 14.7216 7.17782 14.8225 7.26949 14.9234C7.87449 15.5834 8.25033 16.4542 8.25033 17.4167Z"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M5.94942 17.3984H3.21777"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.58398 16.0601V18.8009"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <div>Add Outlet</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/insurance')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="23"
                          height="17"
                          class="icon"
                          viewBox="0 0 23 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.65167 5.56506H21.2169M5.56472 10.1303H8.8256M3.6087 1H19.2605C20.7012 1 21.8691 2.16704 21.8692 3.60775L21.8695 13.3924C21.8695 14.8332 20.7016 16 19.2608 16L3.60895 15.9998C2.16825 15.9998 1.00032 14.8319 1.00028 13.3912L1 3.60877C0.999959 2.168 2.16793 1 3.6087 1Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div>Cashless Insurance service</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/partner-detail')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="23"
                          height="23"
                          class="icon"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.91699 14.6944H3.83366H4.47255L7.66699 17.8889C9.71144 19.4222 11.5003 18.1019 12.1392 17.25C15.2059 17.25 16.3985 15.5463 16.6114 14.6944H21.0837V7.66667H17.8892L15.9725 5.75H6.38921L4.47255 7.66667H1.91699V14.6944Z"
                            fill="#DEE9EA"
                          />
                          <path
                            d="M21.0414 7.15587H18.5975L16.7526 5.31101C16.6252 5.18289 16.4521 5.11133 16.2708 5.11133H11.5002C11.3189 5.11133 11.1458 5.18289 11.0184 5.31101L7.89295 8.43643C7.09558 9.2338 7.09558 10.53 7.89295 11.3274L8.01017 11.4446C8.80754 12.242 10.1038 12.242 10.9011 11.4446L13.3451 9.00072C13.6115 8.73425 13.6115 8.30353 13.3451 8.03706C13.0786 7.77059 12.6479 7.77059 12.3814 8.03706L9.93749 10.481C9.68192 10.7352 9.2294 10.7352 8.97383 10.481L8.85661 10.3637C8.72917 10.2356 8.65897 10.0652 8.65897 9.88192C8.65897 9.69859 8.72985 9.52753 8.85661 9.40009L11.7823 6.47435H15.9886L17.8335 8.31921C17.9609 8.44733 18.134 8.51889 18.3153 8.51889H20.3599V13.971H18.3153C17.9384 13.971 17.6338 14.2756 17.6338 14.6525C17.6338 15.0294 17.9384 15.334 18.3153 15.334H21.0414C21.4183 15.334 21.7229 15.0294 21.7229 14.6525V7.83738C21.7229 7.4605 21.4183 7.15587 21.0414 7.15587Z"
                            fill="#004852"
                          />
                          <path
                            d="M14.0284 10.7631C13.7619 10.4966 13.3312 10.4966 13.0647 10.7631C12.7982 11.0296 12.7982 11.4603 13.0647 11.7268L15.5113 14.1734C15.7124 14.3744 15.7907 14.5905 15.7512 14.8345C15.679 15.2843 15.2285 15.7763 14.6049 16.0878C13.7953 16.4933 12.7587 16.6814 12.2646 16.62C12.0499 16.5914 11.8359 16.6718 11.6874 16.8293C11.1128 17.4392 10.2964 17.8093 9.50311 17.8209C9.04309 17.8256 8.70165 17.7036 8.57625 17.5789L5.16937 14.172C5.10667 14.1087 5.03102 14.0589 4.9472 14.0242C4.86405 13.9887 4.77546 13.971 4.68686 13.971H2.64232V8.51889H4.68686C4.86814 8.51889 5.04125 8.44733 5.16869 8.31921L7.01354 6.47435H8.77594C9.15281 6.47435 9.45745 6.16972 9.45745 5.79284C9.45745 5.41596 9.15281 5.11133 8.77594 5.11133H6.7314C6.55012 5.11133 6.37701 5.18289 6.24957 5.31101L4.40471 7.15587H1.96081C1.58393 7.15587 1.2793 7.4605 1.2793 7.83738V14.6525C1.2793 15.0294 1.58393 15.334 1.96081 15.334H4.40471L7.61259 18.5419C8.02218 18.9515 8.69552 19.1832 9.46767 19.1832C9.48607 19.1832 9.50515 19.1832 9.52356 19.1825C10.5894 19.1675 11.639 18.7375 12.4472 17.9933C12.4534 17.9933 12.4595 17.9933 12.4643 17.9933C13.2821 17.9933 14.3746 17.7261 15.2142 17.3063C16.2474 16.7897 16.9514 15.9467 17.0965 15.0519C17.2062 14.3744 16.9854 13.7195 16.475 13.2091L14.0284 10.7631Z"
                            fill="#004852"
                          />
                        </svg>
                        <div>Partners</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/login-moibile-number')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="18"
                          height="22"
                          viewBox="0 0 18 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 6V16C17 20 16 21 12 21H6C2 21 1 20 1 16V6C1 2 2 1 6 1H12C16 1 17 2 17 6Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17 6V16C17 20 16 21 12 21H6C2 21 1 20 1 16V6C1 2 2 1 6 1H12C16 1 17 2 17 6Z"
                            fill="#DEE9EA"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11 4.5H7"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.0002 18.1C9.85624 18.1 10.5502 17.406 10.5502 16.55C10.5502 15.694 9.85624 15 9.0002 15C8.14415 15 7.4502 15.694 7.4502 16.55C7.4502 17.406 8.14415 18.1 9.0002 18.1Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <div>Login Mobile Numbers</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="handleClickDeactivate(`DEACTIVATE`)"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="20"
                          height="13"
                          class="icon"
                          viewBox="0 0 20 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.65"
                            y="0.65"
                            width="18.7"
                            height="11.7"
                            rx="5.46111"
                            stroke="#004852"
                            stroke-width="1.3"
                          />
                          <circle
                            cx="6.49989"
                            cy="6.49989"
                            r="3.70556"
                            fill="#DEE9EA"
                            stroke="#004852"
                            stroke-width="1.3"
                          />
                        </svg>

                        <div>Deactivate Workshop</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>

              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="handleClickDeactivate(`ACTIVATE`)"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="20"
                          height="13"
                          class="icon"
                          viewBox="0 0 20 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.65"
                            y="0.65"
                            width="18.7"
                            height="11.7"
                            rx="5.46111"
                            stroke="#004852"
                            stroke-width="1.3"
                          />
                          <circle
                            cx="6.49989"
                            cy="6.49989"
                            r="3.70556"
                            fill="#DEE9EA"
                            stroke="#004852"
                            stroke-width="1.3"
                          />
                        </svg>

                        <div>Activate Workshop</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>

              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    class="text-brand"
                    href="javascript:void(0)"
                    v-on:click="this.$router.push('/workshop-details')"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="20"
                          height="20"
                          class="icon"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.3337 8.33317V12.4998C18.3337 16.6665 16.667 18.3332 12.5003 18.3332H7.50033C3.33366 18.3332 1.66699 16.6665 1.66699 12.4998V7.49984C1.66699 3.33317 3.33366 1.6665 7.50033 1.6665H11.667"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M18.3337 8.33317H15.0003C12.5003 8.33317 11.667 7.49984 11.667 4.99984V1.6665L18.3337 8.33317Z"
                            fill="#DEE9EA"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            opacity="0.4"
                            d="M5.83301 10.8335H10.833"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            opacity="0.4"
                            d="M5.83301 14.1665H9.16634"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div>Workshop Documents</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a href="/bank-details" class="text-brand">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="20"
                          height="20"
                          class="icon"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M18 15.3333H2V18H18V15.3333Z" fill="#DEE9EA" />
                          <path
                            d="M2 5.55555V7.33333H18V5.55555L9.67123 2L2 5.55555Z"
                            fill="#DEE9EA"
                          />
                          <path
                            d="M3.33333 12.5V10.2761M7.77778 12.5V10.2761M12.2222 12.5V10.2761M16.6667 12.5V10.2761M2 15.3333H18V18H2V15.3333ZM2 7.33333V5.55555L9.67123 2L18 5.55555V7.33333H2Z"
                            stroke="#004852"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <div>Bank Account Details</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a
                    href="javascript:void(0)"
                    v-on:click="agreement()"
                    class="text-brand"
                  >
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.4418 19.8001H5.04179C3.82676 19.8001 2.84179 18.8152 2.8418 17.6001L2.84188 4.40018C2.84189 3.18516 3.82686 2.2002 5.04188 2.2002H14.9421C16.1572 2.2002 17.1421 3.18517 17.1421 4.40019V10.4502M12.7421 16.6835L14.7588 18.7002L19.1588 14.3M6.69214 6.60019H13.2921M6.69214 9.90019H13.2921M6.69214 13.2002H9.99214"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <div>Agreement</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
              <div class="col-lg-6 mb-3" v-if="is_brand == 'Y'">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a href="javascript:void(0)" v-on:click="gobrands()" class="text-brand">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.1757 3.97438L23.0343 14.321L19.3164 19.2802L14.4707 23.0721L3.68966 12.5387L4.82014 4.81215L13.1757 3.97438Z"
                            fill="#DEE9EA"
                          />
                          <path
                            d="M13.739 23.0035C12.9209 23.0069 12.1348 22.6858 11.5531 22.1106L3.89392 14.4514C3.5858 14.1372 3.3475 13.7615 3.19463 13.3488C3.04176 12.9362 2.97776 12.4959 3.00682 12.0568L3.33731 6.7226C3.39936 5.84506 3.77602 5.01939 4.39809 4.39732C5.02015 3.77525 5.84582 3.39859 6.72337 3.33655L12.0576 3.00606C12.4965 2.97882 12.9363 3.04366 13.3486 3.19644C13.761 3.34921 14.1369 3.58653 14.4522 3.89316L22.1114 11.5524C22.7126 12.2047 23.0313 13.0685 22.9976 13.955C22.9639 14.8416 22.5807 15.6787 21.9316 16.2836L16.2669 21.9309C15.9372 22.2676 15.544 22.5357 15.1102 22.7198C14.6763 22.9039 14.2103 23.0003 13.739 23.0035ZM12.2663 4.44977H12.1329L6.79294 4.77446C6.26928 4.81793 5.77799 5.0457 5.40643 5.41726C5.03487 5.78882 4.8071 6.28011 4.76363 6.80377L4.45633 12.1322C4.43555 12.3693 4.46623 12.6081 4.54629 12.8323C4.62635 13.0564 4.75388 13.2606 4.92018 13.4309L12.562 21.0843C12.7295 21.2464 12.9289 21.3718 13.1475 21.4526C13.3661 21.5335 13.5991 21.568 13.8318 21.554C14.3661 21.5214 14.8688 21.2897 15.2407 20.9046L20.9112 15.2399C21.2859 14.9056 21.5142 14.4373 21.5467 13.9362C21.5792 13.4351 21.4135 12.9412 21.0851 12.5612L13.4433 4.91941C13.2884 4.76648 13.1045 4.64613 12.9023 4.56547C12.7002 4.4848 12.4839 4.44546 12.2663 4.44977Z"
                            fill="#004852"
                          />
                          <path
                            d="M12.55 14.1C13.406 14.1 14.1 13.406 14.1 12.55C14.1 11.694 13.406 11 12.55 11C11.694 11 11 11.694 11 12.55C11 13.406 11.694 14.1 12.55 14.1Z"
                            stroke="#004852"
                            stroke-width="1.3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        <div>Brands</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>

              <div class="col-lg-6 mb-3">
                <div class="card p-3 rounded-4 cursor-pointer nav-card">
                  <a href="/invoice-address" v-on:click="gobrands()" class="text-brand">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex gap-2 align-items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#004852"
                          class="bi bi-receipt-cutoff"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5M11.5 4a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
                          />
                          <path
                            d="M2.354.646a.5.5 0 0 0-.801.13l-.5 1A.5.5 0 0 0 1 2v13H.5a.5.5 0 0 0 0 1h15a.5.5 0 0 0 0-1H15V2a.5.5 0 0 0-.053-.224l-.5-1a.5.5 0 0 0-.8-.13L13 1.293l-.646-.647a.5.5 0 0 0-.708 0L11 1.293l-.646-.647a.5.5 0 0 0-.708 0L9 1.293 8.354.646a.5.5 0 0 0-.708 0L7 1.293 6.354.646a.5.5 0 0 0-.708 0L5 1.293 4.354.646a.5.5 0 0 0-.708 0L3 1.293zm-.217 1.198.51.51a.5.5 0 0 0 .707 0L4 1.707l.646.647a.5.5 0 0 0 .708 0L6 1.707l.646.647a.5.5 0 0 0 .708 0L8 1.707l.646.647a.5.5 0 0 0 .708 0L10 1.707l.646.647a.5.5 0 0 0 .708 0L12 1.707l.646.647a.5.5 0 0 0 .708 0l.509-.51.137.274V15H2V2.118z"
                          />
                        </svg>

                        <div>Invoice Detail</div>
                      </div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 6 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L5 5L1 9"
                          stroke="#001D21"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button
    type="button"
    hidden
    id="add-partner-details"
    class="btn btn-primary"
    data-bs-toggle="modal"
    data-bs-target="#AddPartnerModal"
  ></button>

  <div
    class="modal fade"
    id="AddPartnerModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">AGREEMENT</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="close-modal"
          ></button>
        </div>
        <div class="modal-body">
          <iframe :src="content" width="100%" height="600px"></iframe>
        </div>
        <!-- <div class="modal-footer">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="acknowledged"
            true-value="Y"
            false-value="N"
            id="acknowledged"
          />
          <label class="form-check-label" for="acknowledged"> I Acknowledge </label>
          <button
            type="button"
            class="btn btn-primary"
            id="save-data"
            :disabled="acknowledged == 'N' || user_type != 'OWNER'"
            v-on:click="send()"
          >
            I Acknowledge
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
// import "./onboarding.scss";
export default {
  name: "SettingsList",
  components: {},

  data() {
    return {
      content: "",
      is_cost: "N",
      is_brand: "N",
      brands: [],
      workshop_id: localStorage.getItem("workshop_id"),
    };
  },

  mounted() {
    this.detail();
    localStorage.setItem("page_type", "EDIT");
    this.$store.commit("setPageType", "EDIT");
    localStorage.setItem("is_cost_skip", "N");
    localStorage.setItem("is_photo_skip", "N");
  },
  methods: {
    moveToOutlet() {
      localStorage.setItem("page_type", "ADD_OUTLET");
      this.$store.commit("setPageType", "ADD_OUTLET");
      localStorage.setItem("outlet_workshop_id", "");
      localStorage.setItem("is_cost_skip", "N");
      localStorage.setItem("is_photo_skip", "N");
      this.$router.push("/personal-details");
    },
    detail() {
      this.$api
        .getAPI({
          _action: `workshop-brand-cost/` + this.workshop_id,
        })
        .then((res) => {
          if (res.is_cost == "Y") {
            this.is_cost = "Y";
          }

          if (res.brands.length > 0) {
            this.is_brand = "Y";
            this.brands = res.brands;
          }
        })
        .catch(() => {});
    },
    gobrands() {
      if (this.brands.length > 0) {
        this.$sharedService.setMapValue("Brands", this.brands);
        if (this.brands[0] == "TYRE") {
          this.$router.push("/choose-tyre-brands").then(() => {
            this.$route.params.brands = this.brands;
          });
        } else if (this.brands[0] == "BATTERY") {
          this.$router.push("/choose-battery-brands");
        } else if (this.brands[0] == "CNG") {
          this.$router.push("/choose-cng-brands");
        }
      }
    },
    agreement() {
      this.$api
        .getAPI({
          _action: `get-agreement-detail`,
        })
        .then((res) => {
          this.content = res.url;
          document.getElementById("add-partner-details").click();
        })
        .catch(() => {});
    },
    handleClickDeactivate(type) {
      if (type == "DEACTIVATE") {
        this.$router.push("/deactivate-Workshop");
      } else if (type == "ACTIVATE") {
        this.$router.push("/activate-Workshop");
      } else {
        this.$router.push("/settings");
      }
    },
  },
};
</script>
